import * as React from "react";
import type { SVGProps } from "react";

const VehicleRigidTruck = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M10.6685 12.3354H5.44629"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M12.6661 12.3358H14.0026C14.371 12.3358 14.6696 12.0372 14.6696 11.6689V7.59077C14.6696 7.42116 14.6372 7.25312 14.5742 7.09565L13.6707 4.83741C13.4681 4.33105 12.9776 3.99902 12.4323 3.99902H10.001"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M14.6697 8.66778H12.3354C12.1513 8.66778 12.002 8.51848 12.002 8.33431V6H14.1362"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M12.3729 11.6309C12.659 11.917 12.7446 12.3473 12.5898 12.7211C12.4349 13.095 12.0702 13.3387 11.6655 13.3387C11.2609 13.3388 10.8961 13.095 10.7412 12.7212C10.5864 12.3474 10.6719 11.9171 10.958 11.631L10.9581 11.6309C11.1457 11.4433 11.4002 11.3379 11.6655 11.3379C11.9308 11.3379 12.1852 11.4433 12.3729 11.6309V11.6309"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M5.03691 11.631C5.32304 11.9171 5.40866 12.3474 5.25383 12.7212C5.09901 13.095 4.73423 13.3388 4.3296 13.3388C3.92497 13.3388 3.56017 13.0951 3.4053 12.7213C3.25044 12.3475 3.33601 11.9172 3.62211 11.631L3.62231 11.6308C3.8099 11.4432 4.06434 11.3379 4.32963 11.3379C4.59493 11.3379 4.84934 11.4433 5.0369 11.631V11.631"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M3.33189 12.3357H1.998C1.62966 12.3357 1.33105 12.0371 1.33105 11.6688V3.33198C1.33105 2.96364 1.62966 2.66504 1.998 2.66504H9.33439C9.70273 2.66504 10.0013 2.96364 10.0013 3.33198V9.33448"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M10.0013 9.33445H1.33105"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
));
VehicleRigidTruck.displayName = "VehicleRigidTruck";

export default VehicleRigidTruck;
